import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import '../styles/ManageUsers.css';

function ManageUsersModal({ onClose, currentUserRole }) {
  const [coms, setComs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingUser, setEditingUser] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    role: 'user'
  });
  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/users`, {
        withCredentials: true
      });
      setComs(response.data.users || []);
    } catch (err) {
      toast.error('Failed to load users');
      console.error('Error loading users:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleEditClick = (com) => {
    setEditingUser(com);
    setFormData({
      name: com.name,
      email: com.email,
      password: '',
      role: com.role
    });
  };

  const handleCancelEdit = () => {
    setEditingUser(null);
    setFormData({ name: '', email: '', password: '', role: 'user' });
  };

  const handleSaveEdit = async (e) => {
    e.preventDefault();

    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/users/${editingUser.id}`,
        formData,
        { withCredentials: true }
      );

      toast.success('✅ User updated successfully!');
      setEditingUser(null);
      setFormData({ name: '', email: '', password: '', role: 'user' });
      loadUsers();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to update user');
    }
  };

  const handleDeleteClick = async (com) => {
    if (!window.confirm(`Delete ${com.name}? This cannot be undone.`)) {
      return;
    }

    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/api/users/${com.id}`, {
        withCredentials: true
      });

      toast.success(`🗑️ ${com.name} deleted`);
      loadUsers();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to delete user');
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="manage-users-overlay" onClick={onClose}>
      <div className="manage-users-content" onClick={(e) => e.stopPropagation()}>
        
        <div className="manage-users-header">
          <h2>👥 Manage Users</h2>
          <button onClick={onClose} className="close-button">✕</button>
        </div>

        {loading ? (
          <div className="loading">Loading...</div>
        ) : (
          <div className="coms-table-container">
            <table className="coms-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {coms.map(com => (
                  <tr key={com.id}>
                    {editingUser?.id === com.id ? (
                      // Edit Mode
                      <>
                        <td>
                          <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                          />
                        </td>
                        <td>
                          <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                          />
                        </td>
                        <td>
                          <select
                            name="role"
                            value={formData.role}
                            onChange={handleChange}
                          >
                            <option value="user">👤 User</option>
                            <option value="admin">👑 Admin</option>
                            {currentUserRole === 'superadmin' && (
                              <option value="superadmin">⚡ Super Admin</option>
                            )}
                          </select>
                        </td>
                        <td className="action-buttons">
                          <button onClick={handleSaveEdit} className="btn-save">
                            💾 Save
                          </button>
                          <button onClick={handleCancelEdit} className="btn-cancel">
                            ✕ Cancel
                          </button>
                        </td>
                      </>
                    ) : (
                      // View Mode
                      <>
                        <td>{com.name}</td>
                        <td>{com.email}</td>
                        <td>
                          <span className={`role-badge ${com.role}`}>
                            {com.role === 'superadmin' ? '⚡ Super Admin' : com.role === 'admin' ? '👑 Admin' : '👤 User'}
                          </span>
                        </td>
                        <td className="action-buttons">
                          <button onClick={() => handleEditClick(com)} className="btn-edit">
                            ✏️ Edit
                          </button>
                          {com.role !== 'admin' && com.role !== 'superadmin' && (
                            <button onClick={() => handleDeleteClick(com)} className="btn-delete">
                              🗑️ Delete
                            </button>
                          )}
                        </td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>

            {editingUser && (
              <div className="password-hint">
                <strong>💡 Tip:</strong> Leave password blank to keep current password, or enter a new one to change it.
              </div>
            )}
          </div>
        )}

      </div>
    </div>
  );
}

export default ManageUsersModal;